"use strict";

var _typeof = require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/typeof.js");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.string.iterator");
require("core-js/modules/es6.weak-map");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchFirstLoginPasswordStatus = fetchFirstLoginPasswordStatus;
exports.insertPasswordUpdatePending = insertPasswordUpdatePending;
exports.reportFirstLoginPasswordChanged = reportFirstLoginPasswordChanged;
var _request = _interopRequireWildcard(require("@/utils/request"));
var _auth = require("@/utils/auth");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
/**
 * 查询是否需在 PC 端强制修改登录密码
 * GET agentapi/login/check_password_updated
 * 固定传 source=pc；仅当 data.need_force_password_pc 为 true 且 data.has_password_updated 为 false 时由 store 触发弹窗
 */
function fetchFirstLoginPasswordStatus() {
  return (0, _request.$get)('/agentapi/login/check_password_updated', {
    source: 'pc'
  });
}

/**
 * 用户已完成首次改密后上报（服务端更新 has_password_updated）
 * POST agentapi/login/record_password_updated
 * $post 会在 body 中自动附带 token、user_id、agent_id；另传 update_source: 1 表示来源
 */
function reportFirstLoginPasswordChanged() {
  return (0, _request.$post)('/agentapi/login/record_password_updated', {
    update_source: 1
  });
}

/**
 * 为新建账号写入「待首次改密」记录（添加代理/添加品牌成功后调用）
 * 不能使用 $post：$post 会把 body 里的 user_id/agent_id 覆写为当前登录人
 * @param {{ user_id: number|string, agent_id: number|string, phone: string }} payload 新建用户的 user_id、agent_id，以及创建时填写的登录手机号
 */
function insertPasswordUpdatePending(_ref) {
  var user_id = _ref.user_id,
    agent_id = _ref.agent_id,
    phone = _ref.phone;
  var token = (0, _auth.getToken)() || '';
  var qs = '?token=' + encodeURIComponent(token);
  return _request.default.post('/agentapi/login/insert_password_update' + qs, {
    token: token,
    user_id: user_id,
    agent_id: agent_id,
    phone: phone != null ? String(phone).trim() : ''
  });
}